import React from "react";

interface FilterSkeletonProps {
  isMobile?: boolean;
}

export const FilterSkeleton = ({ isMobile = false }: FilterSkeletonProps) => {
  return (
    <div className={`filter-skeleton ${isMobile ? "mobile" : ""}`}>
      <div className="skeleton-header">
        <div className="skeleton-title"></div>
        <div className="skeleton-done-btn"></div>
      </div>

      {/* UX 분석 필터 */}
      <div className="skeleton-category">
        <div className="skeleton-category-header">
          <div className="skeleton-category-title"></div>
          <div className="skeleton-expand-icon"></div>
        </div>
        <div className="skeleton-items">
          <div className="skeleton-item">
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-item-name"></div>
            <div className="skeleton-count"></div>
          </div>
          <div className="skeleton-item">
            <div className="skeleton-checkbox"></div>
            <div className="skeleton-item-name"></div>
            <div className="skeleton-count"></div>
          </div>
        </div>
      </div>

      {/* 프로덕트 필터 */}
      <div className="skeleton-category">
        <div className="skeleton-category-header">
          <div className="skeleton-category-title"></div>
          <div className="skeleton-expand-icon"></div>
        </div>
        <div className="skeleton-items">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="skeleton-item">
              <div className="skeleton-checkbox"></div>
              <div className="skeleton-item-name"></div>
              <div className="skeleton-count"></div>
            </div>
          ))}
        </div>
      </div>

      {/* 키워드 필터들 */}
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index} className="skeleton-category">
          <div className="skeleton-category-header">
            <div className="skeleton-category-title"></div>
            <div className="skeleton-expand-icon"></div>
          </div>
          <div className="skeleton-items">
            {Array.from({ length: 5 }).map((_, itemIndex) => (
              <div key={itemIndex} className="skeleton-item">
                <div className="skeleton-checkbox"></div>
                <div className="skeleton-item-name"></div>
                <div className="skeleton-count"></div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
